export const SLOT_MENUS = [
  {
    _id: '660bdd13fea7b5f8524fae3a',
    component_content_id: '63806c8e40b4a5aea422f043',
    title: {
      'en-US': '8',
      'th-TH': 'pg2',
      'vi-VN': 'pg2',
      'zh-CN': 'pg2',
      'my-MM': 'Test'
    },
    description: {
      'en-US': '8',
      'th-TH': 'pg2',
      'vi-VN': 'pg2',
      'zh-CN': 'pg2',
      'my-MM': 'Test'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 4327,
    game_provider_id: 52,
    sequence: 12,
    image_desktop_path: {
      'en-US': 'demo/games/slot/image-1-en.png',
      'th-TH': 'demo/games/slot/image-1-th.png',
      'zh-CN': 'demo/games/slot/image-1-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/slot/image-1-en-mobile.png',
      'th-TH': 'demo/games/slot/image-1-th-mobile.png',
      'zh-CN': 'demo/games/slot/image-1-ch-mobile.png'
    },
    __v: 0,
    created_at: '2024-04-02T10:25:23.363Z',
    updated_at: '2025-06-23T07:42:21.782Z',
    image_path: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    },
    link: null
  },
  {
    _id: '660bdd12fea7b5f8524fae36',
    component_content_id: '63806c8e40b4a5aea422f043',
    title: {
      'en-US': '4',
      'th-TH': 'RTG',
      'vi-VN': 'RTG',
      'zh-CN': 'RTG',
      'my-MM': 'Test'
    },
    description: {
      'en-US': '4',
      'th-TH': 'RTG',
      'vi-VN': 'RTG',
      'zh-CN': 'RTG',
      'my-MM': 'Test'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 22318,
    game_provider_id: 21,
    sequence: 4,
    image_desktop_path: {
      'en-US': 'demo/games/slot/image-5-en.png',
      'th-TH': 'demo/games/slot/image-5-th.png',
      'zh-CN': 'demo/games/slot/image-5-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/slot/image-2-en-mobile.png',
      'th-TH': 'demo/games/slot/image-2-th-mobile.png',
      'zh-CN': 'demo/games/slot/image-2-ch-mobile.png'
    },
    __v: 0,
    created_at: '2024-04-02T10:25:23.363Z',
    updated_at: '2025-06-23T07:42:21.477Z',
    image_path: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    }
  },
  {
    _id: '660bdd12fea7b5f8524fae37',
    component_content_id: '63806c8e40b4a5aea422f043',
    title: {
      'en-US': '5',
      'th-TH': 'Red',
      'vi-VN': 'Red',
      'zh-CN': 'World Match ',
      'my-MM': 'Test'
    },
    description: {
      'en-US': '5',
      'th-TH': 'Red',
      'vi-VN': 'Red',
      'zh-CN': 'World Match ',
      'my-MM': 'Test'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 1931,
    game_provider_id: 34,
    sequence: 8,
    image_desktop_path: {
      'en-US': 'demo/games/slot/image-2-en.png',
      'th-TH': 'demo/games/slot/image-2-th.png',
      'zh-CN': 'demo/games/slot/image-2-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/slot/image-2-en-mobile.png',
      'th-TH': 'demo/games/slot/image-2-th-mobile.png',
      'zh-CN': 'demo/games/slot/image-2-ch-mobile.png'
    },
    __v: 0,
    created_at: '2024-04-02T10:25:23.363Z',
    updated_at: '2025-06-23T07:42:21.675Z',
    image_path: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    },
    link: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    }
  },
  {
    _id: '6630a7e3024d8909444e009d',
    component_content_id: '63806c8e40b4a5aea422f043',
    title: {
      'en-US': 'pragmatic play',
      'th-TH': 'pragmatic play',
      'vi-VN': 'pragmatic play',
      'zh-CN': 'pragmatic play',
      'my-MM': 'Test'
    },
    description: {
      'en-US': 'pragmatic play',
      'th-TH': 'pragmatic play',
      'vi-VN': 'pragmatic play',
      'zh-CN': 'pragmatic play',
      'my-MM': 'Test'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 3655,
    game_provider_id: 47,
    sequence: 14,
    image_desktop_path: {
      'en-US': 'demo/games/slot/image-3-en.png',
      'th-TH': 'demo/games/slot/image-3-th.png',
      'zh-CN': 'demo/games/slot/image-3-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/slot/image-3-en-mobile.png',
      'th-TH': 'demo/games/slot/image-3-th-mobile.png',
      'zh-CN': 'demo/games/slot/image-3-ch-mobile.png'
    },
    __v: 0,
    created_at: '2024-04-30T08:12:19.057Z',
    updated_at: '2025-06-23T07:42:21.876Z',
    image_path: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    },
    link: null
  },
  {
    _id: '664573e97f49f566a3f84b2f',
    component_content_id: '63806c8e40b4a5aea422f043',
    title: {
      'en-US': '5',
      'th-TH': 'QS',
      'vi-VN': '5',
      'zh-CN': 'flow',
      'my-MM': 'Test'
    },
    description: {
      'en-US': '5',
      'th-TH': 'QS',
      'vi-VN': '5',
      'zh-CN': 'flow',
      'my-MM': 'Test'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 4440,
    game_provider_id: 53,
    sequence: 10,
    image_desktop_path: {
      'en-US': 'demo/games/slot/image-4-en.png',
      'th-TH': 'demo/games/slot/image-4-th.png',
      'zh-CN': 'demo/games/slot/image-4-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/slot/image-4-en-mobile.png',
      'th-TH': 'demo/games/slot/image-4-th-mobile.png',
      'zh-CN': 'demo/games/slot/image-4-ch-mobile.png'
    },
    __v: 0,
    created_at: '2024-05-16T02:48:09.154Z',
    updated_at: '2025-06-23T07:42:21.688Z',
    image_path: {
      'en-US': null,
      'th-TH': null
    },
    link: null
  },
  {
    _id: '664573e97f49f566a3f84b2a',
    component_content_id: '63806c8e40b4a5aea422f043',
    title: {
      'en-US': '5',
      'th-TH': 'QS',
      'vi-VN': '5',
      'zh-CN': 'flow',
      'my-MM': 'Test'
    },
    description: {
      'en-US': '5',
      'th-TH': 'QS',
      'vi-VN': '5',
      'zh-CN': 'flow',
      'my-MM': 'Test'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 4440,
    game_provider_id: 53,
    sequence: 10,
    image_desktop_path: {
      'en-US': 'demo/games/slot/image-5-en.png',
      'th-TH': 'demo/games/slot/image-5-th.png',
      'zh-CN': 'demo/games/slot/image-5-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/slot/image-5-en-mobile.png',
      'th-TH': 'demo/games/slot/image-5-th-mobile.png',
      'zh-CN': 'demo/games/slot/image-5-ch-mobile.png'
    },
    __v: 0,
    created_at: '2024-05-16T02:48:09.154Z',
    updated_at: '2025-06-23T07:42:21.688Z',
    image_path: {
      'en-US': null,
      'th-TH': null
    },
    link: null
  },
  {
    _id: '664573e97f49f566a3f84b3f',
    component_content_id: '63806c8e40b4a5aea422f043',
    title: {
      'en-US': '5',
      'th-TH': 'QS',
      'vi-VN': '5',
      'zh-CN': 'flow',
      'my-MM': 'Test'
    },
    description: {
      'en-US': '5',
      'th-TH': 'QS',
      'vi-VN': '5',
      'zh-CN': 'flow',
      'my-MM': 'Test'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 4440,
    game_provider_id: 53,
    sequence: 10,
    image_desktop_path: {
      'en-US': 'demo/games/slot/image-6-en.png',
      'th-TH': 'demo/games/slot/image-6-th.png',
      'zh-CN': 'demo/games/slot/image-6-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/slot/image-6-en-mobile.png',
      'th-TH': 'demo/games/slot/image-6-th-mobile.png',
      'zh-CN': 'demo/games/slot/image-6-ch-mobile.png'
    },
    __v: 0,
    created_at: '2024-05-16T02:48:09.154Z',
    updated_at: '2025-06-23T07:42:21.688Z',
    image_path: {
      'en-US': null,
      'th-TH': null
    },
    link: null
  }
]
